import { T } from '@common/hooks/useTranslation';

/**
 * Generates validation rules for the target location field.
 * @param t - The translation function.
 * @returns The validation rules object.
 */
export function targetLocationRules(t: T) {
  return {
    validate: (value: boolean) => {
      if (value === undefined) {
        return t('validations.job.targetLocation.required');
      }
    }
  };
}
